import {
  Appointment,
  CompleteAppointmentDto,
  CreateAppointmentDto,
  FollowUpAppointmentDto,
  StartAppointmentDto,
  TechnicianAppointmentsItem,
  TechnicianAppointmentsQuery,
  TechnicianAppointmentsResult,
  UpdateAppointmentDto,
} from "@myapp/contract";
import apiClient from "../../../shared/config/axios";

export const appointmentApi = {
  create: (data: CreateAppointmentDto) =>
    apiClient.post<Appointment>("/appointments", data),

  update: (id: string, dto: UpdateAppointmentDto) =>
    apiClient.patch<Appointment>(`/appointments/${id}`, dto),

  start: (id: string, dto: StartAppointmentDto) =>
    apiClient.post<Appointment>(`/appointments/${id}/start`, dto),

  complete: (id: string, dto: CompleteAppointmentDto) =>
    apiClient.patch<Appointment>(`/appointments/${id}/complete`, dto),

  followUp: (id: string, dto: FollowUpAppointmentDto) =>
    apiClient.patch<Appointment>(`/appointments/${id}/follow-up`, dto),

  getByTechnicians: (params: TechnicianAppointmentsQuery) =>
    apiClient.get<TechnicianAppointmentsResult>("/appointments/technicians", {
      params,
    }),

  getByTechnicianId: (technicianId: string, params: TechnicianAppointmentsQuery) =>
    apiClient.get<TechnicianAppointmentsItem>(
      `/appointments/technician/${technicianId}`,
      { params },
    ),

  getById: (id: string) =>
    apiClient.get<Appointment>(`/appointments/${id}`),

  getByWorkOrderId: (workOrderId: string) =>
    apiClient.get<Appointment[]>(`/appointments/by-work-order/${workOrderId}`),

  uploadFiles: (files: File[]) => {
    const form = new FormData();
    files.forEach((f) => form.append("files", f));
    return apiClient.post<string[]>("/appointments/upload", form, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
};
